"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle select2
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
require("select2/dist/js/select2.full");
_main_1.txGs1Base.select2 = {
    initialize: function () {
        'use strict';
        var $selectbox = $('[data-selectbox-select2="true"]');
        $selectbox.each(function () {
            var $curSelectbox = $(this);
            var $target = $($curSelectbox.attr('data-selectbox-formatted-option-target'));
            if ($target.length > 0) {
                $curSelectbox.select2({
                    minimumResultsForSearch: Infinity,
                    theme: 'gs1',
                    templateResult: function (state) {
                        if (!state.id || !$target) {
                            return state.text;
                        }
                        return $target.find('[data-option-value="' + state.id + '"]').clone();
                    }
                });
                $curSelectbox.on('change', function (event) {
                    $('.select2-selection__rendered', $curSelectbox.next('.select2')).html($target.find('[data-option-value="' + $curSelectbox.val() + '"]').clone()).css({ 'white-space': 'normal' });
                });
                $curSelectbox.trigger('change');
            }
            else {
                $curSelectbox.select2({
                    minimumResultsForSearch: Infinity,
                    theme: 'gs1'
                });
            }
        });
    }
};
exports.default = {};
